const carouselItems = [
  {
    title: '暑期档·热剧连播',
    desc: '红桃视频夏季重磅剧集集中上线，《逆流时光》《暗夜追踪》等爆款剧集全30集一次性放出，4K画质畅快追剧。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20summer%20cinematic%20atmosphere%20with%20coral%20and%20dark%20tones%2C%20dramatic%20lighting%20with%20sunset%20glow%2C%20film%20poster%20style%20composition%2C%20no%20faces%2C%20vibrant%20yet%20elegant%20mood&width=800&height=450&seq=carousel-01-bale&orientation=landscape',
    tag: '红桃视频',
    tagColor: 'bg-primary-500',
  },
  {
    title: '悬疑剧场·迷雾重重',
    desc: '樱花视频「迷雾剧场」系列全新上线，多部高智商悬疑剧等你来烧脑。每一集都是反转，不到最后一刻猜不到结局。',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20cinematic%20atmosphere%20with%20teal%20and%20dark%20tones%2C%20foggy%20abstract%20composition%2C%20suspenseful%20mood%2C%20dramatic%20contrast%20lighting%2C%20no%20faces%2C%20film%20noir%20aesthetic&width=800&height=450&seq=carousel-02-bale&orientation=landscape',
    tag: '樱花视频',
    tagColor: 'bg-accent-500',
  },
  {
    title: '短剧新势力·竖屏时代',
    desc: '糖豆视频短剧频道全新改版，竖屏沉浸式观看体验。都市情感、搞笑日常、奇幻冒险，每集10分钟，一口气刷完不费劲。',
    img: 'https://readdy.ai/api/search-image?query=Bright%20vertical%20short%20drama%20atmosphere%20with%20warm%20golden%20and%20dark%20tones%2C%20modern%20mobile%20entertainment%20aesthetic%2C%20dynamic%20abstract%20composition%2C%20no%20faces%2C%20energetic%20mood&width=800&height=450&seq=carousel-03-bale&orientation=landscape',
    tag: '糖豆视频',
    tagColor: 'bg-secondary-500',
  },
  {
    title: '经典修复·时光重温',
    desc: '各大平台经典老片修复计划启动，4K数字修复版陆续上线。《山海奇谭》《深夜食堂》等经典佳作以全新画质重现，致敬影史经典。',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20cinematic%20atmosphere%20with%20warm%20sepia%20and%20dark%20tones%2C%20vintage%20film%20texture%2C%20classic%20movie%20aesthetic%2C%20soft%20grain%2C%20elegant%20composition%2C%20no%20faces&width=800&height=450&seq=carousel-04-bale&orientation=landscape',
    tag: '怀旧经典',
    tagColor: 'bg-primary-600',
  },
  {
    title: '海外精选·全球视野',
    desc: '红桃视频海外剧场重磅回归，多部高分美剧、日剧、韩剧独家上线。从艾美奖获奖剧集到亚洲口碑佳作，一网打尽全球好剧。',
    img: 'https://readdy.ai/api/search-image?query=International%20cinematic%20atmosphere%20with%20warm%20coral%20and%20dark%20tones%2C%20global%20film%20collage%20style%2C%20dramatic%20contrast%20lighting%2C%20elegant%20composition%2C%20no%20faces%2C%20sophisticated%20mood&width=800&height=450&seq=carousel-05-bale&orientation=landscape',
    tag: '红桃视频',
    tagColor: 'bg-primary-500',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs font-semibold text-primary-600 uppercase tracking-wider">焦点推荐</span>
          <h2 className="mt-2 text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            焦点推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-500">当前最受关注的特色内容专题</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item, idx) => (
            <a
              key={idx}
              href={idx < 3 ? '#cards' : '#index'}
              className={`group block rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer ${
                idx === 0 ? 'md:col-span-2 lg:col-span-3' : ''
              }`}
            >
              <div className={`relative overflow-hidden bg-background-200 ${
                idx === 0 ? 'aspect-[21/9]' : 'aspect-[16/10]'
              }`}>
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className={`px-3 py-1 rounded-full text-white text-xs font-medium ${item.tagColor}`}>
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-white font-heading font-bold text-lg md:text-xl">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-white/70 text-sm line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}